/** A toolbar select option with its translation key and fallback label. */

/** Block-type options shown in the toolbar's text-style dropdown. */
export var BLOCK_OPTIONS = [{
  value: "paragraph",
  labelKey: "normal_text",
  defaultLabel: "Normal"
}, {
  value: "h1",
  labelKey: "heading_1",
  defaultLabel: "Heading 1"
}, {
  value: "h2",
  labelKey: "heading_2",
  defaultLabel: "Heading 2"
}, {
  value: "h3",
  labelKey: "heading_3",
  defaultLabel: "Heading 3"
}, {
  value: "quote",
  labelKey: "quote",
  defaultLabel: "Quote"
}, {
  value: "code",
  labelKey: "code_block",
  defaultLabel: "Code Block"
}, {
  value: "ul",
  labelKey: "bullet_list",
  defaultLabel: "Bullet List"
}, {
  value: "ol",
  labelKey: "numbered_list",
  defaultLabel: "Numbered List"
}];

/** Alignment options shown in the toolbar's alignment dropdown. */
export var ALIGN_OPTIONS = [{
  value: "left",
  labelKey: "align_left",
  defaultLabel: "Left"
}, {
  value: "center",
  labelKey: "align_center",
  defaultLabel: "Center"
}, {
  value: "right",
  labelKey: "align_right",
  defaultLabel: "Right"
}, {
  value: "justify",
  labelKey: "align_justify",
  defaultLabel: "Justify"
}];

/** Column-layout options (grid-template-columns values) for the columns dropdown. */
export var COLUMN_OPTIONS = [{
  value: "1fr 1fr",
  labelKey: "columns_2",
  defaultLabel: "2 columns"
}, {
  value: "1fr 1fr 1fr",
  labelKey: "columns_3",
  defaultLabel: "3 columns"
}, {
  value: "1fr 1fr 1fr 1fr",
  labelKey: "columns_4",
  defaultLabel: "4 columns"
}, {
  value: "1fr 1fr 1fr 1fr 1fr",
  labelKey: "columns_5",
  defaultLabel: "5 columns"
}];